module.exports = __webpack_public_path__ + "img/placeholder-dark.14799af3.jpeg";